import AccountingDocumentService from "../shared/documentInfrastructure/AccountingDocumentService.js";
import ForecastTemplateService from "../../core/services/ForecastTemplateService.js";
import getKeyFigureService from "../../core/services/getKeyFigureService.js";

/**
 * This is the service for the Forecast on-boarding, in charge of communicating with the backend.
 *
 * @param {Session} session - Session singleton
 * @param {ForecastTemplateService} [forecastTemplateService] - Service to fetch/update a forecast template
 * @param {KeyFigureService} [keyFigureService] - Service to fetch the KPIs
 */
export default class ForecastOnBoardingDocumentService extends AccountingDocumentService {
	constructor({
		session,
		forecastTemplateService = new ForecastTemplateService({
			company: session.getCompany(),
			countryId: session.getCountryId(),
		}),
		keyFigureService = getKeyFigureService(),
	} = {}) {
		super(...arguments);

		this._session = session;
		this._forecastTemplateService = forecastTemplateService;
		this._keyFigureService = keyFigureService;
	}

	async fetchContextData() {
		const chartOfAccountsId = this._session
			.getPeriod()
			.getYear()
			.getChartOfAccountsId();

		const [configuration] = await Promise.all([
			this._forecastTemplateService.getDefaultForecastTemplatesConfiguration(
				{ chartOfAccountsId },
			),
			this._keyFigureService.populateCache(),
		]);

		const allKeyFigures = this._keyFigureService.getAllFromCache();

		return {
			configuration,
			allKeyFigures,
			accounts: this._session.getPeriod().getAccounts(),
			chartOfAccountsId,
			vatPaymentSettings: this._session.getVatPaymentSettings(),
		};
	}

	updateDefaultForecastTemplatesConfiguration(forecastTemplateConfiguration) {
		return this._forecastTemplateService.updateDefaultForecastTemplatesConfiguration(
			forecastTemplateConfiguration,
		);
	}

	create(spec) {
		return this._forecastTemplateService.create(spec);
	}
}
